export default __webpack_public_path__ + "static/media/boat.icon.34c5c516.svg";